import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {},
  state: {
    orderTabs: null,
    CustomerServicePhone: '',
    BuyCarToConfirmData: {},
    ConfirmToPayData: {},
    authIsControlGroupMan: false, // 是否控销组成员
    authIsSubAccount:false, // 是否为子账号好，为子账号时不展示子账号入口
  },
  mutations: {
    _SETORDERTABS(state, data) {
      state.orderTabs = data
    },
    SetBuyCarToConfirmData(state, data) {
      window.localStorage.setItem('BuyCarToConfirmData', JSON.stringify(data));
      //state.BuyCarToConfirmData = data
    },
    SetConfirmToPayData(state, data) {
      window.localStorage.setItem('ConfirmToPayData', JSON.stringify(data));
      //state.ConfirmToPayData = data
    },
    _setControlGroupMan(state, data) {
      state.authIsControlGroupMan = data;
    },
    _setIsSubAccount(state, data){
      state.authIsSubAccount = data
    }
  },
  actions: {

  },
  getters
})